import request from './request';
import type { tStatus } from '@/types/index';

// 活动info
export const getBonusActivityInfo = ({ activityId }: { activityId: string | number }) =>
  request({
    url: '/carbon-promotion/private/user/activity/deposit/homepage',
    method: 'GET',
    params: { activityId }
  });

export const getBonusActivityInfoWithoutAuth = ({ activityId }: { activityId: string | number }) =>
  request({
    url: '/carbon-promotion/public/activity/deposit/homepage',
    method: 'GET',
    params: { activityId }
  });

// 活动历史记录 
export const getBonusActivityHistory = ({ activityId, status, pageIndex, pageSize }: { activityId: string | number, status: tStatus, pageIndex: number, pageSize: number }) =>
  request({
    url: '/carbon-promotion/private/user/activity/deposit/records',
    method: 'GET',
    params: { activityId, status, pageIndex, pageSize }
  });
